var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-1"},[_c('header-sort-button',{attrs:{"color":_vm.highlightIfAsc,"column":_vm.column,"direction":"asc"}}),_c('header-sort-button',{attrs:{"color":_vm.highlightIfDesc,"column":_vm.column,"direction":"desc"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }